import { mediaItems, faqItems, updatesItems } from '@/mocks/homeData';

export function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            视频速递
          </h2>
          <p className="text-[14px] text-foreground-500">最新爆料视频合集，一手掌握热门事件</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-100 rounded-lg overflow-hidden no-underline hover:ring-2 hover:ring-primary-300 transition-all"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/80 text-background-50 text-[11px] rounded font-mono">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-semibold bg-primary-500 text-background-50 rounded">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-[13px] font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-[11px] text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            吃瓜问答
          </h2>
          <p className="text-[14px] text-foreground-500">关于51吃瓜网的常见问题，你想知道的都在这里</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              open
            >
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/50 transition-colors list-none">
                <h3 className="text-[15px] font-semibold text-foreground-900 pr-8">{item.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-6 h-6 items-center justify-center flex-shrink-0 text-primary-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-[14px] text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="text-[24px] md:text-[30px] font-black text-foreground-950 font-heading mb-2">
            最新快讯
          </h2>
          <p className="text-[14px] text-foreground-500">实时追踪娱乐圈动态，一刻不落</p>
        </div>
        <div className="relative pl-8 border-l-2 border-primary-200 space-y-6">
          {updatesItems.map((item) => (
            <div key={item.id} className="relative group">
              <div className="absolute -left-[33px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex items-start gap-3 flex-wrap">
                <span className="text-[12px] font-medium text-foreground-400 whitespace-nowrap mt-0.5">
                  {item.time}
                </span>
                <span className="px-1.5 py-0.5 text-[10px] font-semibold bg-accent-100 text-accent-800 rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <p className="mt-2 text-[14px] md:text-[15px] text-foreground-800 leading-relaxed group-hover:text-primary-700 transition-colors">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}